<div class="be-card row ai-c">
  <button mat-icon-button type="button" class="back-btn" aria-label="Previous" (click)="onPrevious()">
    <i class="material-icons">keyboard_arrow_left</i>
  </button>
  <div class="card-main col">
    <div class="heading">
      {{ (computedData?.from || 'Logistics International') + ' \u2192 ' + (computedData?.to || 'Welisara Limited') }}
    </div>
    <div class="meta col">
      <div class="meta-line">Location Type : {{ computedData?.locationType || 'Partner' }}</div>
      <div class="meta-line">Activity Type : {{ computedData?.activityType || 'CARGO-LOADING-FTL' }}</div>
    </div>

    <div class="badge-row row ai-c">
      <div class="badge row ai-c">
        {{ computedData?.jobId || 'HMTDE-250625-00001 - 1' }}
      </div>
    </div>
    <div class="divider"></div>

    <div class="stats row">
      <div class="stat col">
        <div class="label">Requested Time of Arrival</div>
        <div class="value">{{ computedData?.requestedArrival || '2025-06-25 01:20:PM' }}</div>
      </div>
      <div class="stat col">
        <div class="label">Requested Time of Departure</div>
        <div class="value">{{ computedData?.requestedDeparture || '2025-06-25 01:20:PM' }}</div>
      </div>
      <div class="stat col">
        <div class="label">Estimated Duration</div>
        <div class="value">{{ (computedData?.estimatedDurationMin || 60) }}</div>
      </div>
    </div>
  </div>
  <button mat-icon-button type="button" class="go-btn" aria-label="Proceed" (click)="onProceed()">
    <i class="material-icons">keyboard_arrow_right</i>
  </button>
</div>


